export default "__VITE_ASSET__fe42615e__"